<div class="loaderwrapper" *ngIf="loader">
    <span class="loader"></span>
</div>

<section class="dashboard-main container-fluid" *ngIf="permissionsReady">
    <div class="contents-main">
        <div class="row mb-3">
            <div class="col-12">
                <div class="pg-header align-items-center">
                    <div class="pg-header__crumbs">
                        <h1 class="pg-title">Configurations</h1>
                    </div>
                </div>
            </div>
        </div>

        <nav class="profile-tabs mb-3" aria-label="Configuration sections">
            <button type="button" *ngFor="let tab of tabs" class="profile-tabs__item"
                [class.is-active]="activeTab === tab.key" [attr.aria-current]="activeTab === tab.key ? 'page' : null"
                (click)="selectTab(tab.key)">
                {{ tab.label }}
            </button>
        </nav>

        <ng-container *ngIf="activeTab === 'ticket'">
            <app-ticket-configuration [permissionsOverride]="permissions"></app-ticket-configuration>
        </ng-container>

        <ng-container *ngIf="activeTab === 'fsr'">
            <app-fsr-configuration [permissionsOverride]="permissions"></app-fsr-configuration>
        </ng-container>

        <ng-container *ngIf="activeTab === 'string'">
            <app-string-configuration [permissionsOverride]="permissions"></app-string-configuration>
        </ng-container>

        <ng-container *ngIf="activeTab === 'panel'">
            <app-panel-configuration [permissionsOverride]="permissions"></app-panel-configuration>
        </ng-container>
    </div>
</section>
